// Direct Nav contains source
function isDirectNavMlSourced(directNavSource) {
    return directNavSource && directNavSource === 'ML_AGENT';
}

export {isDirectNavMlSourced};
